<template>
  <Layout>
    <div class="ocpp-operations-main">
      <div class="row">

        <!-- START Configurations -->
        <div class="col-lg-6">
          <div class="card shadow" style="height: 820px">
            <div class="card-body">
              <card-title icon-image="mdi-cog-transfer-outline" title="Operations Management" text-color="title" />

              <!-- // Operations -->
              <div class="row mt-4">
                <b-form-group id="operations"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Operations *" label-for="selectOperations"
                              class="mb-3">
                  <b-form-select class="form-select" id="selectOperations"
                                 v-model="operations" :options="operationsOptions"
                                 @change="changeOperations()" />
                </b-form-group>
              </div>

              <!-- // Charge Point -->
              <div class="row" v-if="chargePoint.show">
                <b-form-group id="chargePoint"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Charge Point *" label-for="selectChargePoint"
                              class="mb-3">
                  <div class="charge-point-box">
                    <component :is="chargePoint.type === 'MULTI' ? 'b-form-checkbox-group' : 'b-form-radio-group'"
                               id="selectChargePoint"
                               v-model="form.chargePoint" :options="chargePoint.options"
                               @change="dataChange('chargePoint')" />
                  </div>
                </b-form-group>
              </div>

              <!-- // Update Type -->
              <div class="row" v-if="updateType.show">
                <b-form-group id="updateType"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Update Type *" label-for="selectUpdateType"
                              class="mb-3">
                  <b-form-select class="form-select" id="selectUpdateType"
                                 v-model="form.updateType" :options="updateType.options"
                                 @change="dataChange('updateType')" />
                </b-form-group>
              </div>

              <!-- // Add Update List & Delete List -->
              <div class="row operation-drag mt-3" v-if="form.updateType === 'DIFFERENTIAL'">
                <div class="col-4 text-center">
                  <div class="font-size-14 mb-3">ID Tag</div>
                  <draggable class="list-group" :list="idTag.options" group="updateType">
                    <div class="list-group-item" v-for="item in idTag.options" :key="item.value">
                      {{ item.text }}
                    </div>
                  </draggable>
                </div>

                <div class="col-4 text-center">
                  <div class="font-size-14 text-primary mb-3">Add Update List</div>
                  <draggable class="list-group" :list="form.addList" group="updateType" @change="dataChange('addList')">
                    <div class="list-group-item" v-for="item in form.addList" :key="item.value">
                      {{ item.text }}
                    </div>
                  </draggable>
                </div>

                <div class="col-4 text-center">
                  <div class="font-size-14 text-primary mb-3">Delete List</div>
                  <draggable class="list-group" :list="form.delList" group="updateType" @change="dataChange('delList')">
                    <div class="list-group-item" v-for="item in form.delList" :key="item.value">
                      {{ item.text }}
                    </div>
                  </draggable>
                </div>
              </div>

              <!-- // Configuration Key -->
              <div class="row" v-if="confKey.show">
                <b-form-group id="confKey"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              :label="`Configure Key ${confKey.required ? '*' : ''}`"
                              label-for="selectConfKey"
                              class="mb-3">
                  <div class="conf-key-box">
                    <component :is="confKey.type === 'MULTI' ? 'b-form-checkbox-group' : 'b-form-radio-group'"
                               id="selectConfKey"
                               v-model="form.confKeyList" :options="confKey.options"
                               @change="dataChange('confKey')" />
                  </div>
                </b-form-group>
              </div>

              <!-- // Comma Separated Custom Configuration Keys -->
              <div class="row" v-if="customConfKey.show">
                <b-form-group id="customConfKey"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              :label="`Custom Conf Keys ${customConfKey.required ? '*' : ''}`"
                              label-for="selectCustomConfKey"
                              class="mb-3">
                  <b-form-input type="text" v-model="form.customConfKey" @input="dataChange('customConfKey')" />
                </b-form-group>
              </div>

              <!-- // Value -->
              <div class="row" v-if="val.show">
                <b-form-group id="val"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Value *"
                              label-for="selectVal"
                              class="mb-3">
                  <b-form-input type="text" v-model="form.value" @input="dataChange('val')" />
                </b-form-group>
              </div>

              <!-- // ID Tag -->
              <div class="row" v-if="idTag.show">
                <b-form-group id="idTag"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="ID Tag *" label-for="selectIdTag"
                              class="mb-3">
                  <b-form-select class="form-select" id="selectIdTag"
                                 v-model="form.idTag" :options="idTag.options"
                                 @change="dataChange('idTag')" />
                </b-form-group>
              </div>

              <!-- // Profile -->
              <div class="row" v-if="profile.show">
                <b-form-group id="profile"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              :label="`Charging Profile ${profile.required ? '*' : ''}`"
                              label-for="selectProfile"
                              class="mb-3">
                  <b-form-select class="form-select" id="selectProfile"
                                 v-model="form.chargingProfilePk" :options="profile.options"
                                 @change="dataChange('chargingProfilePk')" />
                </b-form-group>
              </div>

              <!-- // Profile Purpose -->
              <div class="row" v-if="profilePurpose.show">
                <b-form-group id="profilePurpose"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              :label="`Profile Purpose ${profilePurpose.required ? '*' : ''}`"
                              label-for="selectProfilePurpose"
                              class="mb-3">
                  <b-form-select class="form-select" id="selectProfilePurpose"
                                 v-model="form.profilePurpose" :options="profilePurpose.options"
                                 @change="dataChange('profilePurpose')" />
                </b-form-group>
              </div>

              <!-- // Stack Level -->
              <div class="row" v-if="stackLevel.show">
                <b-form-group id="stackLevel"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              :label="`Stack Level ${stackLevel.required ? '*' : ''}`"
                              label-for="selectStackLevel"
                              class="mb-3">
                  <b-form-input type="number" v-model="form.stackLevel" @input="dataChange('stackLevel')" />
                </b-form-group>
              </div>

              <!-- // Connector ID -->
              <div class="row" v-if="connectorId.show">
                <b-form-group id="connectorId"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              :label="`Connector ID ${connectorId.required ? '*' : ''}`"
                              label-for="selectConnectorId"
                              class="mb-3">
                  <b-form-select class="form-select" id="selectConnectorId"
                                 v-model="form.connectorId" :options="connectorId.options"
                                 @change="dataChange('connectorId')" />
                </b-form-group>
              </div>

              <!-- // Transaction ID -->
              <div class="row" v-if="transactionId.show">
                <b-form-group id="transactionId"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Transaction ID *"
                              label-for="selectTransactionId"
                              class="mb-3">
                  <b-form-select class="form-select" id="selectTransactionId"
                                 v-model="form.transactionId" :options="transactionId.options"
                                 @change="dataChange('transactionId')" />
                </b-form-group>
              </div>

              <!-- // Expiry -->
              <div class="row" v-if="expiry.show">
                <b-form-group id="expiry"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Expiry *"
                              label-for="selectExpiry"
                              class="mb-3">
                  <date-picker type="datetime" id="valid-to-date" lang="ko"
                               v-model="form.expiry"
                               :show-time-panel="showTimePanel" value-type="format"
                               @close="handleOpenChange" @change="dataChange('expiry')">
                    <template v-slot:footer>
                      <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                        {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                      </button>
                    </template>
                  </date-picker>
                </b-form-group>
              </div>

              <!-- // Reservation ID -->
              <div class="row" v-if="reservation.show">
                <b-form-group id="reservationId"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Reservation ID *"
                              label-for="selectReservationId"
                              class="mb-3">
                  <b-form-select class="form-select" id="selectReservationId"
                                 v-model="form.reservationId" :options="reservation.options"
                                 @change="dataChange('reservationId')" />
                </b-form-group>
              </div>

              <!-- // Avail Type -->
              <div class="row" v-if="availType.show">
                <b-form-group id="availType"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Avail Type *"
                              label-for="selectAvailType"
                              class="mb-3">
                  <b-form-select class="form-select" id="selectAvailType"
                                 v-model="form.availType" :options="availType.options"
                                 @change="dataChange('availType')" />
                </b-form-group>
              </div>

              <!-- // Duration In Seconds -->
              <div class="row" v-if="durationInSeconds.show">
                <b-form-group id="durationInSeconds"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Duration In Seconds *"
                              label-for="selectDurationInSeconds"
                              class="mb-3">
                  <b-form-input type="number" v-model="form.durationInSeconds" @input="dataChange('durationInSeconds')" />
                </b-form-group>
              </div>

              <!-- // Charging Rate Unit -->
              <div class="row" v-if="chargingRateUnit.show">
                <b-form-group id="chargingRateUnit"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Charging Rate Unit *"
                              label-for="selectChargingRateUnit"
                              class="mb-3">
                  <b-form-select class="form-select" id="selectChargingRateUnit"
                                 v-model="form.chargingRateUnit" :options="chargingRateUnit.options"
                                 @change="dataChange('chargingRateUnit')" />
                </b-form-group>
              </div>

              <!-- // Trigger Message -->
              <div class="row" v-if="triggerMessage.show">
                <b-form-group id="triggerMessage"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Trigger Message *"
                              label-for="selectTriggerMessage"
                              class="mb-3">
                  <b-form-select class="form-select" id="selectTriggerMessage"
                                 v-model="form.triggerMessage" :options="triggerMessage.options"
                                 @change="dataChange('triggerMessage')" />
                </b-form-group>
              </div>

              <!-- // Vendor ID -->
              <div class="row" v-if="vendorId.show">
                <b-form-group id="vendorId"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Vendor ID *"
                              label-for="selectVendorId"
                              class="mb-3">
                  <b-form-input type="text" v-model="form.vendorId" @input="dataChange('vendorId')" />
                </b-form-group>
              </div>

              <!-- // Message ID -->
              <div class="row" v-if="messageId.show">
                <b-form-group id="messageId"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              :label="`Message ID ${messageId.required ? '*' : ''}`"
                              label-for="selectMessageId"
                              class="mb-3">
                  <b-form-input type="text" v-model="form.messageId" @input="dataChange('messageId')" />
                </b-form-group>
              </div>

              <!-- // Data -->
              <div class="row" v-if="data.show">
                <b-form-group id="data"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              :label="`Data ${data.required ? '*' : ''}`"
                              label-for="selectData"
                              class="mb-3">
                  <b-form-input type="text" v-model="form.data" @input="dataChange('data')" />
                </b-form-group>
              </div>

              <!-- // Location -->
              <div class="row" v-if="location.show">
                <b-form-group id="location"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Location *"
                              label-for="selectLocation"
                              class="mb-3">
                  <b-form-input type="text" v-model="form.location" @input="dataChange('location')" />
                </b-form-group>
              </div>

              <!-- // Request Id -->
              <div class="row" v-if="requestId.show">
                <b-form-group id="requestId"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Request ID *"
                              label-for="selectRequestId"
                              class="mb-3">
                  <b-form-input type="number" v-model="form.requestId" @input="dataChange('requestId')" />
                </b-form-group>
              </div>

              <!-- // Retries -->
              <div class="row" v-if="retries.show">
                <b-form-group id="retries"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              :label="`Retries ${retries.required ? '*' : ''}`"
                              label-for="selectRetries"
                              class="mb-3">
                  <b-form-input type="number" v-model="form.retries" @input="dataChange('retries')" />
                </b-form-group>
              </div>

              <!-- // Retry Interval -->
              <div class="row" v-if="retryInterval.show">
                <b-form-group id="retryInterval"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              :label="`Retry Interval ${retryInterval.required ? '*' : ''}`"
                              label-for="selectRetryInterval"
                              class="mb-3">
                  <b-form-input type="number" v-model="form.retryInterval" @input="dataChange('retryInterval')" />
                </b-form-group>
              </div>

              <!-- // Start -->
              <div class="row" v-if="start.show">
                <b-form-group id="start"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              :label="`Start ${start.required ? '*' : ''}`"
                              label-for="selectStart"
                              class="mb-3">
                  <date-picker type="datetime" id="valid-to-date" lang="ko"
                               v-model="form.start"
                               :show-time-panel="showTimePanel" value-type="format"
                               @close="handleOpenChange" @change="dataChange('start')">
                    <template v-slot:footer>
                      <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                        {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                      </button>
                    </template>
                  </date-picker>
                </b-form-group>
              </div>

              <!-- // Stop -->
              <div class="row" v-if="stop.show">
                <b-form-group id="stop"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              :label="`Stop ${stop.required ? '*' : ''}`"
                              label-for="selectStop"
                              class="mb-3">
                  <date-picker type="datetime" id="valid-to-date" lang="ko"
                               v-model="form.stop"
                               :show-time-panel="showTimePanel" value-type="format"
                               @close="handleOpenChange" @change="dataChange('stop')">
                    <template v-slot:footer>
                      <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                        {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                      </button>
                    </template>
                  </date-picker>
                </b-form-group>
              </div>

              <!-- // Reset Type -->
              <div class="row" v-if="resetType.show">
                <b-form-group id="resetType"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Reset Type *"
                              label-for="selectResetType"
                              class="mb-3">
                  <b-form-select class="form-select" id="selectResetType"
                                 v-model="form.resetType" :options="resetType.options"
                                 @change="dataChange('resetType')" />
                </b-form-group>
              </div>

              <!-- // Retrieve -->
              <div class="row" v-if="retrieve.show">
                <b-form-group id="retrieve"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Retrieve *"
                              label-for="selectRetrieve"
                              class="mb-3">
                  <date-picker type="datetime" id="valid-to-date" lang="ko"
                               v-model="form.retrieve"
                               :show-time-panel="showTimePanel" value-type="format"
                               @close="handleOpenChange" @change="dataChange('retrieve')">
                    <template v-slot:footer>
                      <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                        {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                      </button>
                    </template>
                  </date-picker>
                </b-form-group>
              </div>

              <!-- // Certificate Chain -->
              <div class="row" v-if="certificateChain.show">
                <b-form-group id="certificateChain"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              :label="`Certificate Chain ${certificateChain.required ? '*' : ''}`"
                              label-for="inputCertificateChain"
                              class="mb-3">
                  <b-form-textarea id="inputCertificateChain" v-model="form.certificateChain"
                                   rows="24" max-rows="24" @input="dataChange('certificateChain')" />
                </b-form-group>
              </div>

              <!-- // Hash Algorithm -->
              <div class="row" v-if="hashAlgorithm.show">
                <b-form-group id="hashAlgorithm"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Hash Algorithm *"
                              label-for="selectHashAlgorithm"
                              class="mb-3">
                  <b-form-select class="form-select" id="selectHashAlgorithm"
                                 v-model="form.hashAlgorithm" :options="hashAlgorithm.options"
                                 @change="dataChange('hashAlgorithm')" />
                </b-form-group>
              </div>

              <!-- // Issuer Name Hash -->
              <div class="row" v-if="issuerNameHash.show">
                <b-form-group id="issuerNameHash"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Issuer Name Hash *"
                              label-for="inputIssuerNameHash"
                              class="mb-3">
                  <b-form-input type="text" v-model="form.issuerNameHash" @input="dataChange('issuerNameHash')" />
                </b-form-group>
              </div>

              <!-- // Issuer Key Hash -->
              <div class="row" v-if="issuerKeyHash.show">
                <b-form-group id="issuerKeyHash"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Issuer Key Hash *"
                              label-for="inputIssuerKeyHash"
                              class="mb-3">
                  <b-form-input type="text" v-model="form.issuerKeyHash" @input="dataChange('issuerKeyHash')" />
                </b-form-group>
              </div>

              <!-- // Serial Number -->
              <div class="row" v-if="serialNumber.show">
                <b-form-group id="serialNumber"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Serial Number *"
                              label-for="inputSerialNumber"
                              class="mb-3">
                  <b-form-input type="text" v-model="form.serialNumber" @input="dataChange('serialNumber')" />
                </b-form-group>
              </div>

              <!-- // Trigger Message -->
              <div class="row" v-if="messageTrigger.show">
                <b-form-group id="messageTrigger"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Message Trigger *"
                              label-for="selectMessageTrigger"
                              class="mb-3">
                  <b-form-select class="form-select" id="selectMessageTrigger"
                                 v-model="form.messageTrigger" :options="messageTrigger.options"
                                 @change="dataChange('messageTrigger')" />
                </b-form-group>
              </div>

              <!-- // Certificate Type -->
              <div class="row" v-if="certificateType.show">
                <b-form-group id="certificateType"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Certificate Type *"
                              label-for="selectCertificateType"
                              class="mb-3">
                  <b-form-select class="form-select" id="selectCertificateType"
                                 v-model="form.certificateType" :options="certificateType.options"
                                 @change="dataChange('certificateType')" />
                </b-form-group>
              </div>

              <!-- // Remote Location -->
              <div class="row" v-if="remoteLocation.show">
                <b-form-group id="remoteLocation"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Remote Location *"
                              label-for="selectRemoteLocation"
                              class="mb-3">
                  <b-form-input type="text" v-model="form.remoteLocation" @input="dataChange('remoteLocation')" />
                </b-form-group>
              </div>

              <!-- // Oldest Timestamp -->
              <div class="row" v-if="oldestTimestamp.show">
                <b-form-group id="start"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Oldest Timestamp"
                              label-for="selectOldestTimestamp"
                              class="mb-3">
                  <date-picker type="datetime" id="valid-to-date" lang="ko"
                               v-model="form.oldestTimestamp"
                               :show-time-panel="showTimePanel" value-type="format"
                               @close="handleOpenChange" @change="dataChange('oldestTimestamp')">
                    <template v-slot:footer>
                      <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                        {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                      </button>
                    </template>
                  </date-picker>
                </b-form-group>
              </div>

              <!-- // Latest Timestamp -->
              <div class="row" v-if="latestTimestamp.show">
                <b-form-group id="start"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Latest Timestamp"
                              label-for="selectLatestTimestamp"
                              class="mb-3">
                  <date-picker type="datetime" id="valid-to-date" lang="ko"
                               v-model="form.latestTimestamp"
                               :show-time-panel="showTimePanel" value-type="format"
                               @close="handleOpenChange" @change="dataChange('latestTimestamp')">
                    <template v-slot:footer>
                      <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                        {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                      </button>
                    </template>
                  </date-picker>
                </b-form-group>
              </div>

              <!-- // Log Type -->
              <div class="row" v-if="logType.show">
                <b-form-group id="logType"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Log Type *"
                              label-for="selectLogType"
                              class="mb-3">
                  <b-form-select class="form-select" id="selectLogType"
                                 v-model="form.logType" :options="logType.options"
                                 @change="dataChange('logType')" />
                </b-form-group>
              </div>

              <!-- // Certificate -->
              <div class="row" v-if="certificate.show">
                <b-form-group id="certificate"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Certificate *"
                              label-for="inputCertificate"
                              class="mb-3">
                  <b-form-textarea id="inputCertificate" v-model="form.certificate"
                                   rows="20" max-rows="20" @input="dataChange('certificate')" />
                </b-form-group>
              </div>

              <!-- // Retrieve Date Time -->
              <div class="row" v-if="retrieveDateTime.show">
                <b-form-group id="retrieveDateTime"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Retrieve Date Time *"
                              label-for="selectRetrieveDateTime"
                              class="mb-3">
                  <date-picker type="datetime" id="valid-to-date" lang="ko"
                               v-model="form.retrieveDateTime"
                               :show-time-panel="showTimePanel" value-type="format"
                               @close="handleOpenChange" @change="dataChange('retrieveDateTime')">
                    <template v-slot:footer>
                      <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                        {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                      </button>
                    </template>
                  </date-picker>
                </b-form-group>
              </div>

              <!-- // Install Date Time -->
              <div class="row" v-if="installDateTime.show">
                <b-form-group id="installDateTime"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Install Date Time"
                              label-for="selectInstallDateTime"
                              class="mb-3">
                  <date-picker type="datetime" id="valid-to-date" lang="ko"
                               v-model="form.installDateTime"
                               :show-time-panel="showTimePanel" value-type="format"
                               @close="handleOpenChange" @change="dataChange('installDateTime')">
                    <template v-slot:footer>
                      <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                        {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                      </button>
                    </template>
                  </date-picker>
                </b-form-group>
              </div>

              <!-- // Signing Certificate -->
              <div class="row" v-if="signingCertificate.show">
                <b-form-group id="signingCertificate"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Signing Certificate *"
                              label-for="inputSigningCertificate"
                              class="mb-3">
                  <b-form-textarea id="inputSigningCertificate" v-model="form.signingCertificate"
                                   rows="4" max-rows="4" @input="dataChange('signingCertificate')" />
                </b-form-group>
              </div>

              <!-- // Signature -->
              <div class="row" v-if="signature.show">
                <b-form-group id="Signature"
                              label-class="col-form-label"
                              label-cols="4" content-cols="8"
                              label="Signature *"
                              label-for="inputSignature"
                              class="mb-3">
                  <b-form-textarea id="inputSignature" v-model="form.signature"
                                   rows="4" max-rows="4" @input="dataChange('signature')" />
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
        <!-- END Configurations -->

        <!-- START Request & Response -->
        <div class="col-lg-6">
          <div class="row h-50">
            <div class="col-lg-12">
              <div class="card card-height-100 shadow">
                <div class="card-body">
                  <card-title icon-image="mdi-database-arrow-right" title="Request" text-color="title" />
                  <div class="request-data-table">
                    <pre>{{ requestText }}</pre>
                  </div>
                  <div class="mt-3 text-align-end">
                    <b-button size="sm" variant="outline-primary" @click="execute()">Execute</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row h-50">
            <div class="col-lg-12">
              <div class="card card-height-100 shadow">
                <div class="card-body">
                  <card-title icon-image="mdi-database-arrow-left" title="Response" text-color="title" />
                  <div class="response-data-table">
                    <pre>{{ response }}</pre>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END Request & Response -->

      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/main.vue';
import CardTitle from '@/views/components/cardTitle.vue';
import draggable from 'vuedraggable';

export default {
  components: { Layout, CardTitle, draggable },
  data() {
    return {
      operations: null,
      operationsOptions: [],
      chargePoint: { show: false, type: 'MULTI', options: [] },
      updateType: {
        show: false,
        options: [{ value: 'FULL', text: 'FULL' }, { value: 'DIFFERENTIAL', text: 'DIFFERENTIAL' }]
      },
      idTag: { show: false, options: [] },
      confKey: { show: false, type: 'MULTI', options: [], required: true },
      customConfKey: { show: false, required: true },
      val: { show: false },
      profile: { show: false, options: [], required: true },
      profilePurpose: { show: false, options: [{ value: 'ChargePointMaxProfile', text: 'Charge Point Max Profile' },
          { value: 'TxDefaultProfile', text: 'Tx Default Profile' },
          { value: 'TxProfile', text: 'Tx Profile' }], required: true },
      connectorId: { show: false, options: [], required: true },
      stackLevel: { show: false, required: true },
      transactionId: { show: false, options: [] },
      expiry: { show: false },
      reservation: { show: false, options: [] },
      availType: { show: false, options: [{ value: 'INOPERATIVE', text: 'INOPERATIVE' }, { value: 'OPERATIVE', text: 'OPERATIVE' }] },
      durationInSeconds: { show: false },
      chargingRateUnit: { show: false, options: [{ value: 'W', text: 'W' }, { value: 'A', text: 'A' }] },
      triggerMessage: {
        show: false,
        options: [
          { value: 'BootNotification', text: 'Boot Notification' },
          { value: 'DiagnosticsStatusNotification', text: 'Diagnostics Status Notification' },
          { value: 'FirmwareStatusNotification', text: 'Firmware Status Notification' },
          { value: 'Heartbeat', text: 'Heartbeat' },
          { value: 'MeterValues', text: 'Meter Values' },
          { value: 'StatusNotification', text: 'Status Notification' }
        ]
      },
      vendorId: { show: false },
      messageId: { show: false, required: true },
      data: { show: false, required: true },
      location: { show: false },
      retries: { show: false, required: true },
      retryInterval: { show: false, required: true },
      start: { show: false, required: true },
      stop: { show: false, required: true },
      resetType: { show: false, options: [{ value: 'HARD', text: 'HARD' }, { value: 'SOFT', text: 'SOFT' }] },
      retrieve: { show: false },
      certificateChain: { show: false, required: true },
      hashAlgorithm: {
        show: false,
        required: true,
        options: [
          { value: 'SHA256', text: 'SHA256' },
          { value: 'SHA384', text: 'SHA384' },
          { value: 'SHA512', text: 'SHA512' }
        ]
      },
      issuerNameHash: { show: false, required: true },
      issuerKeyHash: { show: false, required: true },
      serialNumber: { show: false, required: true },
      messageTrigger: {
        show: false,
        options: [
          { value: 'BootNotification', text: 'Boot Notification' },
          { value: 'LogStatusNotification', text: 'Log Status Notification' },
          { value: 'FirmwareStatusNotification', text: 'Firmware Status Notification' },
          { value: 'Heartbeat', text: 'Heartbeat' },
          { value: 'MeterValues', text: 'Meter Values' },
          { value: 'SignChargePointCertificate', text: 'Sign Charge Point Certificate' },
          { value: 'StatusNotification', text: 'Status Notification' }
        ]
      },
      certificateType: {
        show: false,
        options: [
          { value: 'CentralSystemRootCertificate', text: 'Central System Root Certificate' },
          { value: 'ManufacturerRootCertificate', text: 'Manufacturer Root Certificate' }
        ]
      },
      remoteLocation: { show: false },
      oldestTimestamp: { show: false },
      latestTimestamp: { show: false },
      logType: {
        show: false,
        options: [
          { value: 'DiagnosticsLog', text: 'Diagnostics Log' },
          { value: 'SecurityLog', text: 'Security Log' }
        ]
      },
      requestId: { show: false },
      certificate: { show: false },
      retrieveDateTime: { show: false },
      installDateTime: { show: false },
      signingCertificate: { show: false },
      signature: { show: false },
      form: {
        chargePoint: [],
        updateType: null,
        addList: [],
        delList: [],
        confKeyList: [],
        customConfKey: null,
        value: null,
        idTag: null,
        chargingProfilePk: null,
        connectorId: null,
        profilePurpose: null,
        stackLevel: null,
        transactionId: null,
        expiry: null,
        reservationId: null,
        availType: null,
        durationInSeconds: null,
        chargingRateUnit: null,
        triggerMessage: null,
        vendorId: 'net.i-on.ev',
        messageId: null,
        data: null,
        location: 'https://ev.i-on.net/rest/upload/diagnostics',
        retries: null,
        retryInterval: null,
        start: null,
        stop: null,
        resetType: null,
        retrieve: null,
        certificateChain: null,
        hashAlgorithm: null,
        issuerNameHash: null,
        issuerKeyHash: null,
        serialNumber: null,
        messageTrigger: null,
        certificateType: null,
        remoteLocation: 'sftp://ev.i-on.net/rest/upload/diagnostics',
        oldestTimestamp: null,
        latestTimestamp: null,
        logType: null,
        requestId: null,
        certificate: null,
        retrieveDateTime: null,
        installDateTime: null,
        signingCertificate: null,
        signature: null
      },
      showTimePanel: false,
      request: {},
      requestText: null,
      response: null
    }
  },
  mounted() {
    const vm = this;

    vm.getOperationsOptions();
    vm.getChargePointOptions();
    vm.getIdTagOptions();
    vm.getProfileOptions();
  },
  methods: {
    getOperationsOptions() {
      const vm = this;

      vm.operationsOptions = [];
      vm.operationsOptions = Object.entries(this.$_app.code.operation).map(([key, value]) => ({ value: key, text: value }));
    },
    getChargePointOptions() {
      const vm = this;

      vm.chargePoint.options = [];
      this.$_app.service.chargePoint.list()
          .then(res => {
            res.forEach(item => {
              vm.chargePoint.options.push({ value: item.chargeBoxId, text: item.chargeBoxId });
            })
          }).catch(err => {
            console.log(err);
          });
    },
    getIdTagOptions() {
      const vm = this;

      vm.idTag.options = [];
      this.$_app.service.idTag.list()
          .then(res => {
            res.forEach(item => {
              vm.idTag.options.push({ value: item.idTag, text: item.idTag });
            })
          }).catch(err => {
            console.log(err);
          });
    },
    getProfileOptions() {
      const vm = this;

      vm.profile.options = [];
      this.$_app.service.chargingProfile.list()
          .then(res => {
            res.forEach(item => {
              vm.profile.options.push(
                  { value: item.chargingProfilePk, text: item.profileName, purpose: item.chargingProfilePurpose, stackLevel: item.stackLevel }
              );
            })
          }).catch(err => {
            console.log(err);
          });
    },
    getOperations() {
      const vm = this;

      this.$axios.get(`/rest/ocpp/operations/v1.6/${vm.operations}`, {
        headers: {
          Authorization: `I-ON-EV`
        }
      }).then((res) => {
        vm.confKey.options = Object.entries(res.data.ocppConfKeys).map(([key, value]) => ({
          value: key,
          text: `${key} (${value.match(/\(([^)]+)\)/)[1]})`
        }));
      })
    },
    getConnectorIdOptions(val) {
      const vm = this;
      const _url = `/onmapi/ocpp/charge-point/GetConnectorIds/${vm.operations}/${val}`;

      vm.connectorId.options = [];
      this.$axios.get(_url)
          .then((res) => {
            console.log('res', res)
            vm.connectorId.options = res.data.map(item => Object.keys(item)[0]);
          })
          .catch((error) => {
            this.$swal('Connector ID 데이터 조회 실패', '', 'error');
            console.error(error)
          });
    },
    getTransactionIdOptions(val) {
      const vm = this;
      const _url = `/onmapi/ocpp/transaction/GetTransactionId/${val}`;

      vm.transactionId.options = [];
      this.$axios.get(_url)
          .then((res) => {
            res.data.forEach(item => {
              vm.transactionId.options.push({ value: item.transactionId, text: item.transactionId });
            })
          })
          .catch((error) => {
            this.$swal('Transaction ID 데이터 조회 실패', '', 'error');
            console.error(error)
          });
    },
    getReservations(val) {
      const vm = this;

      vm.reservation.options = [];
      this.$_app.service.reservation.searchByJql({chargeBoxId: val})
          .then(res => {
            res.forEach(item => {
              vm.reservation.options.push({ value: item.reservationId, text: item.reservationId });
            })
          }).catch(err => {
            console.log(err);
          });
    },
    reset() {
      const vm = this;

      vm.chargePoint.show = false;
      vm.chargePoint.type = 'MULTI';

      vm.updateType.show = false;

      vm.idTag.show = false;

      vm.confKey.show = false;
      vm.confKey.type = 'MULTI';
      vm.confKey.required = true;

      vm.customConfKey.show = false;
      vm.customConfKey.required = true;

      vm.val.show = false;

      vm.profile.show = false;
      vm.profile.required = true;

      vm.profilePurpose.show = false;
      vm.profilePurpose.required = true;

      vm.connectorId.show = false;
      vm.connectorId.required = true;

      vm.stackLevel.show = false;
      vm.stackLevel.required = true;

      vm.transactionId.show = false;

      vm.expiry.show = false;

      vm.reservation.show = false;

      vm.availType.show = false;

      vm.durationInSeconds.show = false;

      vm.chargingRateUnit.show = false;

      vm.triggerMessage.show = false;

      vm.vendorId.show = false;

      vm.messageId.show = false;
      vm.messageId.required = true;

      vm.data.show = false;
      vm.data.required = true;

      vm.location.show = false;

      vm.retries.show = false;
      vm.retries.required = true;

      vm.retryInterval.show = false;
      vm.retryInterval.required = true;

      vm.start.show = false;
      vm.start.required = true;

      vm.stop.show = false;
      vm.stop.required = true;

      vm.resetType.show = false;

      vm.retrieve.show = false;

      vm.certificateChain.show = false;
      vm.certificateChain.required = true;

      vm.hashAlgorithm.show = false;

      vm.issuerNameHash.show = false;
      vm.issuerKeyHash.show = false;

      vm.serialNumber.show = false;

      vm.messageTrigger.show = false;

      vm.certificateType.show = false;

      vm.remoteLocation.show = false;

      vm.oldestTimestamp.show = false;
      vm.latestTimestamp.show = false;

      vm.logType.show = false;

      vm.requestId.show = false;

      vm.certificate.show = false;

      vm.retrieveDateTime.show = false;

      vm.installDateTime.show = false;

      vm.signingCertificate.show = false;
      vm.signature.show = false;

      vm.form = {
        chargePoint: [],
        updateType: null,
        addList: [],
        delList: [],
        confKeyList: [],
        customConfKey: null,
        value: null,
        idTag: null,
        chargingProfilePk: null,
        connectorId: null,
        profilePurpose: null,
        stackLevel: null,
        transactionId: null,
        expiry: null,
        reservationId: null,
        availType: null,
        durationInSeconds: null,
        chargingRateUnit: null,
        triggerMessage: null,
        vendorId: 'net.i-on.ev',
        messageId: null,
        data: null,
        location: 'https://ev.i-on.net/rest/upload/diagnostics',
        retries: null,
        retryInterval: null,
        start: null,
        stop: null,
        resetType: null,
        retrieve: null,
        certificateChain: null,
        hashAlgorithm: null,
        issuerNameHash: null,
        issuerKeyHash: null,
        serialNumber: null,
        messageTrigger: null,
        certificateType: null,
        remoteLocation: 'sftp://ev.i-on.net/rest/upload/diagnostics',
        oldestTimestamp: null,
        latestTimestamp: null,
        logType: null,
        requestId: null,
        certificate: null,
        retrieveDateTime: null,
        installDateTime: null,
        signingCertificate: null,
        signature: null
      }

      vm.request = {};
      vm.requestText = null;
      vm.response = null;
    },
    changeOperations() {
      const vm = this;
      vm.reset();

      vm.chargePoint.show = true;

      if (vm.operations === 'SendLocalList') {
        vm.updateType.show = true;

        vm.getIdTagOptions();
      } else if (vm.operations === 'GetConfiguration') {
        vm.confKey.show = true;
        vm.confKey.required = false;
        vm.customConfKey.show = true;
        vm.customConfKey.required = false;

        vm.getOperations();
      } else if (vm.operations === 'ChangeConfiguration') {
        vm.confKey.show = true;
        vm.confKey.type = 'SINGLE';
        vm.val.show = true;

        vm.getOperations();
      } else if (vm.operations === 'SetChargingProfile') {
        vm.profile.show = true;
        vm.connectorId.show = true;
      } else if (vm.operations === 'ClearChargingProfile') {
        vm.profile.show = true;
        vm.profile.required = true;
        vm.profilePurpose.show = true;
        vm.profilePurpose.required = false;
        vm.connectorId.show = true;
        vm.connectorId.required = false;
        vm.stackLevel.show = true;
        vm.stackLevel.required = false;
      } else if (vm.operations === 'RemoteStartTransaction') {
        vm.chargePoint.type = 'SINGLE';
        vm.idTag.show = true;
        vm.connectorId.show = true;
        vm.connectorId.required = false;
      } else if (vm.operations === 'RemoteStopTransaction') {
        vm.chargePoint.type = 'SINGLE';
        vm.transactionId.show = true;
      } else if (vm.operations === 'ReserveNow') {
        vm.chargePoint.type = 'SINGLE';
        vm.connectorId.show = true;
        vm.idTag.show = true;
        vm.expiry.show = true;
      } else if (vm.operations === 'CancelReservation') {
        vm.chargePoint.type = 'SINGLE';
        vm.reservation.show = true;
      } else if (vm.operations === 'ChangeAvailability') {
        vm.connectorId.show = true;
        vm.availType.show = true;
      } else if (vm.operations === 'GetCompositeSchedule') {
        vm.connectorId.show = true;
        vm.durationInSeconds.show = true;
        vm.chargingRateUnit.show = true;
      } else if (vm.operations === 'TriggerMessage') {
        vm.triggerMessage.show = true;
        vm.connectorId.show = true;
        vm.connectorId.required = false;
      } else if (vm.operations === 'DataTransfer') {
        vm.vendorId.show = true;
        vm.messageId.show = true;
        vm.messageId.required = false;
        vm.data.show = true;
        vm.data.required = false;

        vm.request['vendorId'] = vm.form.vendorId;
      } else if (vm.operations === 'GetDiagnostics') {
        vm.location.show = true;
        vm.retries.show = true;
        vm.retries.required = false;
        vm.retryInterval.show = true;
        vm.retryInterval.required = false;
        vm.start.show = true;
        vm.start.required = false;
        vm.stop.show = true;
        vm.stop.required = false;

        vm.request['location'] = vm.form.location;
      } else if (vm.operations === 'Reset') {
        vm.resetType.show = true;
      } else if (vm.operations === 'UpdateFirmware') {
        vm.location.show = true;
        vm.retries.show = true;
        vm.retries.required = false;
        vm.retryInterval.show = true;
        vm.retryInterval.required = false;
        vm.retrieve.show = true;

        vm.request['location'] = vm.form.location;
      } else if (vm.operations === 'UnlockConnector') {
        vm.chargePoint.type = 'SINGLE';
        vm.connectorId.show = true;
      } else if (vm.operations === 'CertificateSigned') {
        vm.certificateChain.show = true;
      } else if (vm.operations === 'DeleteCertificate') {
        vm.hashAlgorithm.show = true;
        vm.issuerNameHash.show = true;
        vm.issuerKeyHash.show = true;
        vm.serialNumber.show = true;
      } else if (vm.operations === 'ExtendedTriggerMessage') {
        vm.messageTrigger.show = true;

        vm.connectorId.show = true;
        vm.connectorId.required = false;
      } else if (vm.operations === 'GetInstalledCertificateIds') {
        vm.certificateType.show = true;
      } else if (vm.operations === 'GetLog') {
        vm.remoteLocation.show = true;
        vm.request['remoteLocation'] = vm.form.remoteLocation;

        vm.oldestTimestamp.show = true;
        vm.latestTimestamp.show = true;

        vm.logType.show = true;

        vm.requestId.show = true;

        vm.retries.show = true;
        vm.retries.required = false;

        vm.retryInterval.show = true;
        vm.retryInterval.required = false;
      } else if (vm.operations === 'InstallCertificate') {
        vm.certificateType.show = true;
        vm.certificate.show = true;
      } else if (vm.operations === 'SignedUpdateFirmware') {
        vm.form.location = 'https://ev.i-on.net/rest/download/firmware';
        vm.location.show = true;
        vm.request['location'] = vm.form.location;

        vm.retrieveDateTime.show = true;
        vm.installDateTime.show = true;

        vm.signingCertificate.show = true;
        vm.signature.show = true;

        vm.retries.show = true;
        vm.retries.required = false;

        vm.retryInterval.show = true;
        vm.retryInterval.required = false;

        vm.requestId.show = true;
      }
    },
    dataChange(type) {
      const vm = this;

      if (type === 'chargePoint') {
        let cpArray = [];
        let chargePointText = '';

        if (vm.chargePoint.type === 'MULTI') {
          vm.form.chargePoint.forEach((item, index) => {
            cpArray.push({ 'chargeBoxId': item });
            chargePointText += item;
            chargePointText += vm.form.chargePoint.length === index+1 ? '' : ',';
          });
        } else if (vm.chargePoint.type === 'SINGLE') {
          cpArray.push({ 'chargeBoxId': vm.form.chargePoint })
          chargePointText = vm.form.chargePoint;
        }

        vm.request['chargePointSelectList'] = cpArray;

        if (vm.operations === 'SetChargingProfile' || vm.operations === 'ClearChargingProfile'
            || vm.operations === 'RemoteStartTransaction' || vm.operations === 'ReserveNow'
            || vm.operations === 'ChangeAvailability' || vm.operations === 'GetCompositeSchedule'
            || vm.operations === 'TriggerMessage' || vm.operations === 'UnlockConnector'
            || vm.operations === 'ExtendedTriggerMessage') {
          vm.getConnectorIdOptions(chargePointText);
        } else if (vm.operations === 'RemoteStopTransaction') {
          vm.getTransactionIdOptions(chargePointText);
        } else if (vm.operations === 'CancelReservation') {
          vm.getReservations(chargePointText);
        }
      } else if (type === 'updateType') {
        vm.request['updateType'] = vm.form.updateType;

        if (vm.form.updateType === 'DIFFERENTIAL') {
          vm.request['addUpdateList'] = [];
          vm.request['deleteList'] = [];
        } else {
          delete vm.request.addUpdateList;
          delete vm.request.deleteList;

          vm.getIdTagOptions();
          vm.form.addList = [];
          vm.form.delList = [];
        }
      } else if (type === 'addList') {
        let addArray = [];

        vm.form.addList.forEach(item => {
          addArray.push(item.value);
        })

        vm.request['addUpdateList'] = addArray;
      } else if (type === 'delList') {
        let delArray = [];

        vm.form.delList.forEach(item => {
          delArray.push(item.value)
        })

        vm.request['deleteList'] = delArray;
      } else if (type === 'confKey') {
        if (vm.operations === 'ChangeConfiguration') {
          vm.request['confKey'] = vm.form.confKeyList;
        } else {
          vm.request['confKeyList'] = vm.form.confKeyList;
        }
      } else if (type === 'customConfKey') {
        vm.request['commaSeparatedCustomConfKeys'] = vm.form.customConfKey;
      } else if (type === 'val') {
        vm.request['value'] = vm.form.value;
      } else if (type === 'chargingProfilePk') {
        vm.request['chargingProfilePk'] = vm.form.chargingProfilePk;
      } else if (type === 'connectorId') {
        vm.request['connectorId'] = parseInt(vm.form.connectorId);
      } else if (type === 'profilePurpose') {
        vm.request['chargingProfilePurposeStr'] = vm.form.profilePurpose;
      } else if (type === 'stackLevel') {
        vm.request['stackLevel'] = parseInt(vm.form.stackLevel);
      } else if (type === 'idTag') {
        vm.request['idTag'] = vm.form.idTag;
      } else if (type === 'transactionId') {
        vm.request['transactionId'] = vm.form.transactionId;
      } else if (type === 'expiry') {
        vm.request['expiry'] = vm.form.expiry;
      } else if (type === 'reservationId') {
        vm.request['reservationId'] = vm.form.reservationId;
      } else if (type === 'availType') {
        vm.request['availType'] = vm.form.availType;
      } else if (type === 'durationInSeconds') {
        vm.request['durationInSeconds'] = parseInt(vm.form.durationInSeconds);
      } else if (type === 'chargingRateUnit') {
        vm.request['chargingRateUnit'] = vm.form.chargingRateUnit;
      } else if (type === 'triggerMessage') {
        vm.request['triggerMessage'] = vm.form.triggerMessage;
      } else if (type === 'vendorId') {
        vm.request['vendorId'] = vm.form.vendorId;
      } else if (type === 'messageId') {
        vm.request['messageId'] = vm.form.messageId;
      } else if (type === 'data') {
        vm.request['data'] = vm.form.data;
      } else if (type === 'location') {
        vm.request['location'] = vm.form.location;
      } else if (type === 'retries') {
        vm.request['retries'] = parseInt(vm.form.retries);
      } else if (type === 'retryInterval') {
        vm.request['retryInterval'] = parseInt(vm.form.retryInterval);
      } else if (type === 'start') {
        vm.request['start'] = vm.form.start;
      } else if (type === 'stop') {
        vm.request['stop'] = vm.form.stop;
      } else if (type === 'resetType') {
        vm.request['resetType'] = vm.form.resetType;
      } else if (type === 'retrieve') {
        vm.request['retrieve'] = vm.form.retrieve;
      } else if (type === 'certificateChain') {
        vm.request['certificateChain'] = vm.form.certificateChain;
      } else if (type === 'hashAlgorithm') {
        vm.request['hashAlgorithm'] = vm.form.hashAlgorithm;
      } else if (type === 'issuerNameHash') {
        vm.request['issuerNameHash'] = vm.form.issuerNameHash;
      } else if (type === 'issuerKeyHash') {
        vm.request['issuerKeyHash'] = vm.form.issuerKeyHash;
      } else if (type === 'serialNumber') {
        vm.request['serialNumber'] = vm.form.serialNumber;
      } else if (type === 'messageTrigger') {
        vm.request['messageTrigger'] = vm.form.messageTrigger;
      } else if (type === 'certificateType') {
        vm.request['certificateType'] = vm.form.certificateType;
      } else if (type === 'remoteLocation') {
        vm.request['remoteLocation'] = vm.form.remoteLocation;
      } else if (type === 'oldestTimestamp') {
        vm.request['oldestTimestamp'] = vm.form.oldestTimestamp;
      } else if (type === 'latestTimestamp') {
        vm.request['latestTimestamp'] = vm.form.latestTimestamp;
      } else if (type === 'logType') {
        vm.request['logType'] = vm.form.logType;
      } else if (type === 'requestId') {
        vm.request['requestId'] = vm.form.requestId;
      } else if (type === 'certificate') {
        vm.request['certificate'] = vm.form.certificate;
      } else if (type === 'retrieveDateTime') {
        vm.request['retrieveDateTime'] = vm.form.retrieveDateTime;
      } else if (type === 'installDateTime') {
        vm.request['installDateTime'] = vm.form.installDateTime;
      } else if (type === 'signingCertificate') {
        vm.request['signingCertificate'] = vm.form.signingCertificate;
      } else if (type === 'signature') {
        vm.request['signature'] = vm.form.signature;
      }

      vm.requestText = JSON.stringify(vm.request, null, '\t');
    },
    execute() {
      const vm = this;

      this.$axios.post(`/rest/ocpp/operations/v1.6/${vm.operations}`, vm.request, {
        headers: {
          Authorization: `I-ON-EV`
        }
      }).then((res) => {
        vm.$nextTick(() => {
          vm.getLog();
        })
      })
    },
    getLog() {
      const vm = this;
      const _url = `/onmapi/ocpp/log/search/60`;

      this.$axios.get(_url)
          .then((res) => {
            vm.response = JSON.stringify(res.data, null, '\t');
          })
          .catch((error) => {
            this.$swal('Log 데이터 조회 실패', '', 'error');
            console.error(error)
          });
    },
    handleOpenChange() {
      const vm = this;
      vm.showTimePanel = false;
    },
    toggleTimePanel() {
      const vm = this;
      vm.showTimePanel = !vm.showTimePanel;
    }
  }
}
</script>